import { render, staticRenderFns } from "./OnSiteMessageCreateAndFilter.vue?vue&type=template&id=19133b3e&scoped=true&"
import script from "./OnSiteMessageCreateAndFilter.vue?vue&type=script&lang=js&"
export * from "./OnSiteMessageCreateAndFilter.vue?vue&type=script&lang=js&"
import style0 from "./OnSiteMessageCreateAndFilter.vue?vue&type=style&index=0&id=19133b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19133b3e",
  null
  
)

export default component.exports